import React from 'react';
export function Footer() {
  return <footer className="bg-white py-16 border-t border-slate-100" data-id="element-1779">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1780">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 mb-16" data-id="element-1781">
          <div className="col-span-2 lg:col-span-2" data-id="element-1782">
            <div className="flex items-center gap-2 mb-6" data-id="element-1783">
              <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center" data-id="element-1784">
                <div className="w-3 h-3 border-2 border-white rounded-full border-t-transparent transform rotate-45" data-id="element-1785"></div>
              </div>
              <span className="font-bold text-2xl tracking-tight text-slate-900" data-id="element-1786">
                openmart
              </span>
            </div>
            <p className="text-slate-500 text-sm leading-relaxed max-w-xs mb-6" data-id="element-1787">
              The premier local business data API, local business API, and
              Google Places API alternative. A powerful local business search
              API for modern data teams.
            </p>
            <div className="flex space-x-4" data-id="element-1788">
              <a href="#" className="text-slate-400 hover:text-blue-600 transition-colors" data-id="element-1789">
                <span className="sr-only" data-id="element-1790">Twitter</span>
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-1791">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-1792" />
                </svg>
              </a>
              <a href="#" className="text-slate-400 hover:text-blue-600 transition-colors" data-id="element-1793">
                <span className="sr-only" data-id="element-1794">LinkedIn</span>
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-1795">
                  <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" data-id="element-1796" />
                </svg>
              </a>
            </div>
          </div>

          <div data-id="element-1797">
            <h4 className="text-slate-900 font-bold text-sm mb-4" data-id="element-1798">Features</h4>
            <ul className="space-y-3" data-id="element-1799">
              <li data-id="element-1800">
                <a href="#/local-business-api" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1801">
                  Local business API
                </a>
              </li>
              <li data-id="element-1802">
                <a href="#/google-maps-scraper" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1803">
                  Google Maps scraper
                </a>
              </li>
              <li data-id="element-1804">
                <a href="#/local-business-database" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1805">
                  Local business database
                </a>
              </li>
              <li data-id="element-1806">
                <a href="#/local-business-enrichment" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1807">
                  Data enrichment
                </a>
              </li>
              <li data-id="element-1808">
                <a href="#/owner-finder" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1809">
                  Owner finder
                </a>
              </li>
              <li data-id="element-1810">
                <a href="#/local-marketing" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1811">
                  Local marketing
                </a>
              </li>
              <li data-id="element-1812">
                <a href="#/email-sequencing" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1813">
                  Email sequencing
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-1814">
            <h4 className="text-slate-900 font-bold text-sm mb-4" data-id="element-1815">Products</h4>
            <ul className="space-y-3" data-id="element-1816">
              <li data-id="element-1817">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1818">
                  Search
                </a>
              </li>
              <li data-id="element-1819">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1820">
                  Enrich
                </a>
              </li>
              <li data-id="element-1821">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1822">
                  Engage
                </a>
              </li>
              <li data-id="element-1823">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1824">
                  API
                </a>
              </li>
              <li data-id="element-1825">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1826">
                  Integrations
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-1827">
            <h4 className="text-slate-900 font-bold text-sm mb-4" data-id="element-1828">
              Industries
            </h4>
            <ul className="space-y-3" data-id="element-1829">
              <li data-id="element-1830">
                <a href="#/data/accounting" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1831">
                  Accounting
                </a>
              </li>
              <li data-id="element-1832">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1833">
                  Healthcare
                </a>
              </li>
              <li data-id="element-1834">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1835">
                  Home Services
                </a>
              </li>
              <li data-id="element-1836">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1837">
                  Retail
                </a>
              </li>
              <li data-id="element-1838">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1839">
                  Real Estate
                </a>
              </li>
              <li data-id="element-1840">
                <a href="#/data" className="text-slate-500 hover:text-blue-600 text-sm transition-colors font-medium" data-id="element-1841">
                  View all 300+
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-1842">
            <h4 className="text-slate-900 font-bold text-sm mb-4" data-id="element-1843">Company</h4>
            <ul className="space-y-3" data-id="element-1844">
              <li data-id="element-1845">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1846">
                  About us
                </a>
              </li>
              <li data-id="element-1847">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1848">
                  Careers
                </a>
              </li>
              <li data-id="element-1849">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1850">
                  Blog
                </a>
              </li>
              <li data-id="element-1851">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1852">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 mb-12" data-id="element-1853">
          <div className="col-span-2 lg:col-span-2" data-id="element-1854"></div>

          <div data-id="element-1855">
            <h4 className="text-slate-900 font-bold text-sm mb-4" data-id="element-1856">Use Cases</h4>
            <ul className="space-y-3" data-id="element-1857">
              <li data-id="element-1858">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1859">
                  Sales Teams
                </a>
              </li>
              <li data-id="element-1860">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1861">
                  Marketing Agencies
                </a>
              </li>
              <li data-id="element-1862">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1863">
                  SaaS Companies
                </a>
              </li>
              <li data-id="element-1864">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1865">
                  Investors
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-1866">
            <h4 className="text-slate-900 font-bold text-sm mb-4" data-id="element-1867">
              Comparisons
            </h4>
            <ul className="space-y-3" data-id="element-1868">
              <li data-id="element-1869">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1870">
                  vs Google Places
                </a>
              </li>
              <li data-id="element-1871">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1872">
                  vs Apollo
                </a>
              </li>
              <li data-id="element-1873">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1874">
                  vs ZoomInfo
                </a>
              </li>
              <li data-id="element-1875">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1876">
                  vs Yelp API
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-1877">
            <h4 className="text-slate-900 font-bold text-sm mb-4" data-id="element-1878">Legal</h4>
            <ul className="space-y-3" data-id="element-1879">
              <li data-id="element-1880">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1881">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-1882">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1883">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-1884">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1885">
                  Cookie Policy
                </a>
              </li>
              <li data-id="element-1886">
                <a href="#" className="text-slate-500 hover:text-blue-600 text-sm transition-colors" data-id="element-1887">
                  DPA
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-100 flex flex-col md:flex-row justify-between items-center" data-id="element-1888">
          <p className="text-slate-400 text-sm" data-id="element-1889">
            © {new Date().getFullYear()} Openmart Inc. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-1890">
            <div className="flex items-center gap-2 text-sm text-slate-500" data-id="element-1891">
              <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-1892"></span>
              All systems operational
            </div>
          </div>
        </div>
      </div>
    </footer>;
}